import {Component} from '@angular/core';
import {SelectedService} from "../../../shared/services/selected.service";
import {AsyncPipe} from "@angular/common";
import {DialogComponent} from "@common-module/dialog/dialog/dialog.component";
import {UnitInfoCarouselComponent} from "../../main/unit-info-carousel/unit-info-carousel.component";

@Component({
  selector: 'app-unit-info-carousel-dialog',
  imports: [
    AsyncPipe,
    DialogComponent,
    UnitInfoCarouselComponent,
  ],
  templateUrl: './unit-info-carousel-dialog.component.html',
  styleUrl: './unit-info-carousel-dialog.component.scss'
})
export class UnitInfoCarouselDialogComponent {

  constructor(public selectedService: SelectedService) {
  }


}
